import { hbs } from 'ember-cli-htmlbars';
import { workflowComponent } from '@banking/ui/services/unit-balance';
import { ActionCreator } from '@banking/ui/workflows/balance';

// For the template

const template = hbs`
  <Banking::BillPay::PayBillsModal
    @canSeePrintableCheck={{this.canSeePrintableCheck}}
    @onClickSendPayment={{@onClickSendPayment}}
    @onClickWriteAndDownloadCheck={{this.clickWriteAndDownloadCheck}}
    @close={{@close}}
  />
`;
const mapStateToProps = state => ({
  // We assume this state to have been already initialized from the workflow from stored-balance
  canSeePrintableCheck: state.canSeePrintableCheck
});
const mapActionsToProps = ownArgs => ({
  clickWriteAndDownloadCheck: () => {
    ownArgs.onClickWriteAndDownloadCheck();
    return ActionCreator.userClickOpenCreatePrintableCheck();
  }
});
export default workflowComponent(mapStateToProps, mapActionsToProps)(template);